import React from 'react';
import ServiceLandingPage from './ServiceLandingPage';
import { pageMeta, faq, sections, steps } from '../content/debtSettlementContent';

const DebtSettlementLawyerPage = () => (
  <ServiceLandingPage {...pageMeta} faq={faq} sections={sections} steps={steps} />
);

export default DebtSettlementLawyerPage;
